import { render, staticRenderFns } from "./AuthorizationPage.vue?vue&type=template&id=694906ee&"
import script from "./AuthorizationPage.vue?vue&type=script&lang=js&"
export * from "./AuthorizationPage.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizationPage.vue?vue&type=style&index=0&id=694906ee&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports